import { render, staticRenderFns } from "./PaymentProvisionList.vue?vue&type=template&id=67b86b46&scoped=true&"
import script from "./PaymentProvisionList.vue?vue&type=script&lang=js&"
export * from "./PaymentProvisionList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentProvisionList.vue?vue&type=style&index=0&id=67b86b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b86b46",
  null
  
)

export default component.exports